import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import ReactAudioPlayer from 'react-audio-player';
import AudioRecorder from "../AudioRecorder";
import TimeRecord from "../TimeRecord";
import TimeChuanBi from "../TimeChuanBi";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';


const TypeNoi = (props) => {
    const { data, indexCauHoi, indexNhom, onSubmitAnswer, onAutoNext, overview = false, selected = null } = props;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const audioPlayerRef = useRef(null);
    const audioRef = useRef(null); // Ref cho audio element
    const [isPlaying, setIsPlaying] = useState(false); // State để track trạng thái phát audio
    const [isHalfPlayed, setIsHalfPlayed] = useState(false);
    const [showtimechuanbi, setshowtimechuanbi] = useState(false);
    const [showAnswer, setshowAnswer] = useState(false);
    const [showRecord, setShowRecord] = useState(false);
    const [showTimeRecord, setShowTimeRecord] = useState(false);
    const [showBtnAnswer, setshowBtnAnswer] = useState(false);
    const [finish, setFinish] = useState(false);
    const [recordingKey, setRecordingKey] = useState(0); // Key để reset AudioRecorder
    const [audioFileUrl, setAudioFileUrl] = useState(null); // URL file audio từ MinIO
    const [isSpeaking, setIsSpeaking] = useState(false); // Voice activity state từ mic
    const [showInstructions, setShowInstructions] = useState(false); // Hiện panel "Instructions..." khi audio đang phát
    const toast = useRef(null);
    const userId = localStorage.getItem('User_Id');
    const IdDeThi = localStorage.getItem('IdDeThi');

    // Tự động tính lượt nghe đầu tiên nếu có autoPlay + hiện Instructions panel
    useEffect(() => {
        if (data?.file && data?.file.includes('.mp3')) {
            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');
            if (currentCount === 0) {
                localStorage.setItem(playCountKey, '1');
            }
            // Hiện panel Instructions khi có audio (audio đang phát)
            setShowInstructions(true);
        } else {
            setShowInstructions(false);
        }
    }, [data?.id]);

    // Sync state khi audio play/pause (cho autoPlay)
    useEffect(() => {
        const audioEl = audioRef.current;
        if (!audioEl) return;

        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);

        audioEl.addEventListener('play', handlePlay);
        audioEl.addEventListener('pause', handlePause);

        return () => {
            audioEl.removeEventListener('play', handlePlay);
            audioEl.removeEventListener('pause', handlePause);
        };
    }, []);

    const onShowTimeRecore = () => {
        setShowTimeRecord(true);
    }

    const handleRecordAgain = () => {
        // Reset tất cả state để ghi lại
        setFinish(false);
        setShowTimeRecord(false);
        setshowBtnAnswer(false);
        setShowRecord(true);
        setAudioFileUrl(null); // Reset audio URL
        setRecordingKey(prev => prev + 1); // Tăng key để force re-render AudioRecorder
    }

    const handleAudioUploaded = async (url) => {
        // Log URL để debug
        console.log('✅ File đã upload lên MinIO thành công!');
        console.log('📁 Đường dẫn file:', url);

        // Lưu URL vào state
        setAudioFileUrl(url);

        // Submit audio URL chạy ngầm (fire & forget) - không chặn luồng chính
        if (onSubmitAnswer && data?.id) {
            const userId = localStorage.getItem('User_Id');
            const attemptCode = localStorage.getItem('exam_attempt_code');
            const IdDeThi = localStorage.getItem('IdDeThi');
            const typeExam = localStorage.getItem('typeExam');

            onSubmitAnswer({
                id_cauhoi: data.id,
                vanbantraloi: url,
                user_id: userId,
                attempt_code: attemptCode || null,
                dethitructuyen_id: IdDeThi,
                type_exam: typeExam,
                loaibaithi: 1
            }).then(() => {
                console.log('✅ Đã submit answer với URL:', url);
            }).catch(error => {
                console.error('❌ Submit answer error:', error);
            });
        }

        return url;
    }

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho câu hỏi này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                // Tránh tăng đếm 2 lần nếu autoPlay đã tăng rồi
                if (currentCount > 0 || (currentCount === 0 && !el.autoplay)) {
                    const newCount = currentCount + 1;
                    localStorage.setItem(playCountKey, newCount);
                } else if (currentCount === 0 && el.autoplay) {
                    // Nếu là lượt đầu và có autoplay, useEffect đã lo hoặc đã tự phát
                    // Nhưng nếu nó chưa phát, ta vẫn nên tính
                }
            }
        } catch (e) {
            // ignore play error
        }
    };

    const handleListen = (e) => {
        // const audio = audioPlayerRef.current.audioEl.current; // Truy cập đối tượng trình phát
        // const duration = audio.duration; // Lấy duration từ audio
        // const currentTime = audio.currentTime;

        // if (duration && currentTime >= duration / 2 && !isHalfPlayed) {
        //     setIsHalfPlayed(true);
        //     console.log('Tệp âm thanh đã phát được 50%!');
        //     // Thực hiện các hành động khác ở đây
        // }
    };

    // Phát tiếng bíp ngắn để báo hiệu chuẩn bị ghi âm
    const playBeep = () => {
        try {
            const audio = new Audio('/images/beep-sound.mp3');
            audio.play().catch(() => {
                // ignore beep error
            });
        } catch (e) {
            // ignore beep error
        }
    };

    const handleEnded = () => {
        // Ẩn Instructions panel khi audio kết thúc
        setShowInstructions(false);
        if (indexNhom != 3) {
            setShowRecord(true);
        }
        else {
            setshowtimechuanbi(true);
        }
        setIsPlaying(false);
        playBeep();
    };

    const onFinish = () => {
        setFinish(!finish);
        setShowTimeRecord(false);
        setshowBtnAnswer(true);

        // Chuyển câu ngay lập tức - upload/submit chạy ngầm
        if (onAutoNext) {
            setTimeout(() => {
                onAutoNext();
            }, 500);
        }
    }

    const startNow = () => {
        playBeep();
        setShowRecord(true);
        setshowtimechuanbi(false);
    }

    if (overview) {
        return (
            <div className="conatiner-div1" style={{ padding: '20px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
                <div style={{ marginBottom: 20 }}>
                    <h5 style={{ color: '#1e293b', marginBottom: 10 }}>Câu hỏi (Question):</h5>
                    <div dangerouslySetInnerHTML={{ __html: data?.vanbancauhoi ? he.decode(data.vanbancauhoi) : '' }} />
                    {data?.file && (
                        <div style={{ marginTop: 15 }}>
                            <audio controls src={data.file} style={{ width: '100%', height: 40 }} />
                        </div>
                    )}
                </div>

                <div style={{ padding: '15px', background: '#fff', borderRadius: '10px', border: '1px dashed #cbd5e1' }}>
                    <h5 style={{ color: '#0f172a', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <i className="pi pi-microphone" style={{ color: '#ef4444' }}></i>
                        Bài làm của bạn (Your Recording):
                    </h5>
                    {selected ? (
                        <audio controls src={selected} style={{ width: '100%', height: 45 }} />
                    ) : (
                        <p style={{ color: '#64748b', fontStyle: 'italic', margin: 0 }}>Bạn chưa thực hiện ghi âm cho câu hỏi này.</p>
                    )}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="conatiner-div1">
                <div className="d-flex m2-3" style={{ justifyContent: 'start', marginRight: '10%' }}>
                    <div className="mr-3 mb-3 mt-3">
                        <span>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: data?.vanbancauhoi ? he.decode(data.vanbancauhoi) : ''
                                }}
                            />
                        </span>
                    </div>
                </div>
                {/* {
                    data?.des != '' &&
                    <div className="d-flex m2-3" style={{ justifyContent: 'start', marginRight: '10%' }}>
                        <div className="mr-3 mb-3 mt-3">
                            <span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: data?.des || ''
                                    }}
                                />
                            </span>
                        </div>
                    </div>
                } */}


                {data?.file && data?.file.includes('.mp3') && (
                    <div style={{ marginTop: '20px', marginBottom: '20px', width: '100%' }}>
                        <audio
                            controlsList="nodownload"
                            key={data?.id}
                            ref={audioRef}
                            style={{ display: 'none' }}
                            onEnded={handleEnded}
                            autoPlay
                        >
                            <source src={data?.file} type="audio/ogg" />
                            <source src={data?.file} type="audio/mpeg" />
                        </audio>
                    </div>
                )}

                {
                    showRecord &&
                    <div style={{ marginBottom: '20px' }}>
                        <AudioRecorder
                            key={recordingKey}
                            finish={finish}
                            onStartRecore={() => onShowTimeRecore()}
                            onAudioUploaded={handleAudioUploaded}
                            onSpeakingChange={setIsSpeaking}
                            questionId={data?.id}
                            previousAudioUrl={audioFileUrl}
                        >

                        </AudioRecorder>
                    </div>
                }

                {/* Hiển thị URL file sau khi upload thành công */}
                {/* {audioFileUrl && (
                    <div style={{ 
                        marginTop: '15px', 
                        padding: '10px', 
                        background: '#d4edda', 
                        border: '1px solid #c3e6cb', 
                        borderRadius: '5px',
                        fontSize: '14px'
                    }}>
                        <div style={{ fontWeight: '600', marginBottom: '5px', color: '#155724' }}>
                            ✅ File đã được upload thành công!
                        </div>
                        <div style={{ color: '#155724', wordBreak: 'break-all' }}>
                            <strong>Đường dẫn file:</strong> {audioFileUrl}
                        </div>
                    </div>
                )} */}



                {showBtnAnswer &&
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {/* <div className="col-4 col-md-3" style={{
                            background: '#23085a',
                            color: 'white', padding: '10px 20px',
                            borderRadius: '8px', cursor: 'pointer',
                            textAlign: 'center'
                        }} onClick={() => setshowAnswer(true)}>
                            Đáp án gợi ý
                        </div> */}
                        {/* <div className="col-4 col-md-3" style={{
                            background: '#28a745',
                            color: 'white', padding: '10px 20px',
                            borderRadius: '8px', cursor: 'pointer',
                            textAlign: 'center'
                        }} onClick={handleRecordAgain}>
                            Ghi lại
                        </div> */}
                    </div>
                }

                {/* {showAnswer &&
                    <div className="" style={{ marginTop: '80px' }}>
                        <span style={{ fontSize: '24px', fontWeight: '600' }}>Answer</span>
                        <div className="mt-3 mb-3">
                            {data && data.lstdapan
                                .filter(item => item.fileupload !== null && item.fileupload !== '')
                                .map((item, index) => {
                                    return (
                                        <div className="mt-2" key={index}>
                                            <audio controlsList="nodownload" controls>
                                                <source src={item.fileupload} type="audio/ogg" />
                                                <source src={item.fileupload} type="audio/mpeg" />
                                            </audio>
                                        </div>
                                    );
                                })}
                            {
                                data.vanbangiaithich &&
                                <div style={{ color: 'red', fontWeight: '600', marginLeft: 10 }}>Giải thích :
                                    <span style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: data.vanbangiaithich }}></span>
                                </div>
                            }
                        </div>


                    </div>
                } */}


            </div>

            {/* Panel Instructions — hiện khi audio đang phát, ẩn khi audio kết thúc */}
            <Dialog
                visible={showInstructions}
                position='top-right'
                closable={false}
                modal={false}
                showHeader={false}
                style={{
                    width: isMobile ? '80vw' : '20vw',
                    height: '90vh'
                }}
                onHide={() => { }}
                draggable={false}
                resizable={false}
            >
                <div style={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center', marginTop: 30 }}>
                        <span style={{ fontSize: '24px', fontWeight: '700' }}>Instructions...</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '15%' }}>
                        <div style={{
                            width: 200, height: 200, borderRadius: '50%',
                            border: '3px dashed #c4b5e3',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            background: '#fff',
                            boxShadow: '0 0 26px #1507b729',
                            animation: 'pulse 2s ease-in-out infinite',
                        }}>
                            <i className="pi pi-volume-up" style={{ fontSize: 52, color: '#23085a' }} />
                        </div>
                    </div>
                </div>
                <style>{`
                    @keyframes pulse {
                        0%, 100% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.05); opacity: 0.85; }
                    }
                `}</style>
            </Dialog>

            <TimeRecord
                visible={showTimeRecord}
                indexCauHoi={indexCauHoi}
                indexNhom={indexNhom}
                isSpeaking={isSpeaking}
                onFinish={() => onFinish()}

            >
            </TimeRecord>

            <TimeChuanBi
                visible={showtimechuanbi}
                startNow={() => startNow()}

            >
            </TimeChuanBi>


            <Toast ref={toast} />
        </>
    );
}

export default TypeNoi;